import { useEffect } from 'react';
import { FAMILIARISE_STATE } from '@core/dashboard/components/HomeBottomBar/constants';
import { Screens } from '@features/TrainerTools/interfaces';
import { useTrainerToolsContent } from '@features/TrainerTools/provider';
import { useTrainerTools } from '@features/TrainerTools';
import { useHomeBottomBarContext } from '@core/dashboard/components/HomeBottomBar/providers/HomeBottomBarProvider';
import { useParticipantList } from '@core/dashboard/components/HomeBottomBar/Participants';
import { useScreenShare } from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';

const useFamiliarizationTrainerTool = () => {
  const { sendMessageToUnreal } = useMytaverse();
  const { familiarizeState } = useMytaverseEvent();

  const { setOpen: setOpenTrainerTool } = useTrainerTools();
  const { setActiveScreen, activeObject } = useTrainerToolsContent();
  const { open: isTrainerToolsOpen } = useTrainerTools();

  const { openRaisedHands, closeRaisedHands } = useHomeBottomBarContext();
  const { setOpen: openParticipants } = useParticipantList();
  const handleShareScreen = useScreenShare();

  useEffect(() => {
    if (
      !familiarizeState ||
      familiarizeState.name !== FAMILIARISE_STATE.TRAINER_TOOLS
    ) {
      return;
    }

    if (familiarizeState.payload === FAMILIARISE_STATE['3D_OBJECTS']) {
      setOpenTrainerTool(true);
      setActiveScreen(Screens.COLLECTION);
    } else if (familiarizeState.payload === FAMILIARISE_STATE.RISE_HAND) {
      setOpenTrainerTool(true);
      setActiveScreen(Screens.INIT);
      openRaisedHands();
    } else if (familiarizeState.payload === FAMILIARISE_STATE.TRAINER_TOOLS) {
      setOpenTrainerTool(true);
      setActiveScreen(Screens.INIT);
    } else if (familiarizeState.payload === FAMILIARISE_STATE.VIDEO_CONTROLS) {
      setActiveScreen(Screens.INIT);
      closeRaisedHands();
      openParticipants(true);
    } else if (familiarizeState.payload === FAMILIARISE_STATE.SCREEN_SHARE) {
      setActiveScreen(Screens.INIT);
      handleShareScreen();
    }
  }, [familiarizeState]);

  useEffect(() => {
    if (activeObject || isTrainerToolsOpen) {
      return;
    }

    if (
      !isTrainerToolsOpen &&
      familiarizeState?.name === FAMILIARISE_STATE.TRAINER_TOOLS &&
      familiarizeState?.payload === FAMILIARISE_STATE['3D_OBJECTS']
    ) {
      sendMessageToUnreal({ action: 'FAMILIARIZATION_CLOSED' });
    }
  }, [isTrainerToolsOpen, activeObject, familiarizeState]);
};

export default useFamiliarizationTrainerTool;
